import React, { useEffect, useState } from 'react';
import { Box, Typography, List, ListItem, Link, CircularProgress,Paper,ListItemText, IconButton ,Tooltip } from '@mui/material';
import {main_url} from  './basefile';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomSnackbar from './CustomSnackbar';

const DocumentList_exe = ({obj_id}) => {
  const [documents, setDocuments] = useState();
  const [loading, setLoading] = useState(true);
   const [snackbarOpen1, setSnackbarOpen1] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const handleDelete = async (doc) => {
    
        let deleteId =doc.id ;
        try{
         
          // http://3.17.38.106:8000/api/v1/documents/40/
          const res = await fetch(`${main_url}/api/v1/documents/${deleteId}/`, {
          method: 'DELETE',
          headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}` 
                  },
          });

          if (!res.ok) {
              throw new Error('Failed to delete' + res.status);
          }
  
          // Update state and UI after success
          
            setSnackbarMessage('Document deleted  !');
            setSnackbarSeverity('success');
            setSnackbarOpen1(true);
            setDocuments(documents.filter((doc) => doc.id !== deleteId));

        } catch (error) {
          alert('ERROR Failed to delete document' + error );
        }
  };
  
const getFileNameFromUrl = (url) => {
  // Remove query parameters (anything after ?)
  const cleanUrl = url.split('?')[0];

  // Split the path by "/" and get the last part
  const segments = cleanUrl.split('/');
  return segments[segments.length - 1];
};

//alert(obj_id);
  useEffect(() => {
    fetchDocuments();
  }, []);


const token  = localStorage.getItem('authToken');
  const fetchDocuments = async () => {
    try {
       
         const res = await fetch(`${main_url}/api/v1/executions/${obj_id}`, {
          headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) {
        const error = await res.text();
        throw new Error(error);
      }

      const data = await res.json();
       // alert(JSON.stringify(data.documents));
      setDocuments(data.documents );
    } catch (err) {
      console.error('Failed to fetch documents:', err.message);
      alert('Failed to load documents');
    } finally {
      setLoading(false);
    }
  };


  
  return (
     <Box
      minHeight="4vh"
      display="flex"
      justifyContent="left"
      alignItems="center"
      //bgcolor="#f0f2f5"
    >
      <Paper
        elevation={2}
        sx={{
          p: 2,
          width: '100%',
          maxWidth: 800,
          borderRadius: 3,
           border: '1px solid #ccc',
          backgroundColor: '#ffffff',
          
        }}
      >
        <Typography variant="h5" gutterBottom align="left" ml={2} >
          Attachments
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" mt={2} >
            <CircularProgress />
          </Box>
        ) : documents.length > 0 ? (
          <List >
            {documents.map((doc, index) => (
              <ListItem key={doc} divider 
                   secondaryAction={
                         <Tooltip title="Delete Document" >
                          <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(doc)}>
                            <DeleteIcon />
                          </IconButton>
                          </Tooltip>
                        }
              > 
                <ListItemText
                  primary={
                    <Link
                      href={doc.presigned_url}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                    >
                     { `${index+1}.    ${ getFileNameFromUrl( doc.presigned_url)}`}
                    </Link>
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography variant="body1" color="text.secondary" align="center" mt={2}>
            No documents uploaded yet.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default DocumentList_exe;
